<template>
  <a-config-provider :locale="chinese">
    <div id="jbx">
      <router-view v-if="isRouterAlive" />
    </div>
  </a-config-provider>
</template>

<script>
import chinese from 'ant-design-vue/lib/locale-provider/zh_CN'
import enquireScreen from './utils/device'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  name: 'Jiebao',
  provide: function () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      chinese,
      isRouterAlive: true,
      intervalTime: null
    }
  },
  // beforeCreate () {
  //   console.log('this.font =>', this.font)
  //   document.documentElement.style.setProperty('--font-family', this.font)
  // },
  computed: {
    ...mapState({
      isMobile: state => state.setting.isMobile,
      systemName: state => state.setting.systemName,
      fixSiderbar: state => state.setting.fixSiderbar,
      font: state => state.setting.font,
      globalFont: state => state.setting.globalFont
    })
  },
  watch: {
    font: {
      handler (newVal, oldVal) {
        document.querySelector(':root').style.setProperty('--fontFam', newVal)
      },
      deep: true,
      immediate: true
    },
    globalFont: {
      handler (newVal, oldVal) {
        document.querySelector(':root').style.setProperty('--globalFont', newVal)
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    const _this = this
    enquireScreen(isMobile => {
      // console.log(isMobile)
      _this.$store.commit('setting/setDevice', isMobile)
    })
    // 添加监听浏览器页面是否更新函数
    this.checkVersionHandler()
  },
  methods: {
    // 页面刷新不闪屏
    reload: function () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    // 检查版本更新
    checkVersion (time) {
      let that = this
      this.intervalTime = setInterval(() => {
        axios({
          url: `${window.location.origin}/static/version.json`, // 当前页面地址+json文件
          method: 'get',
          timeout: 60000
        }).then(({ status, data }) => {
          if (status === 200) {
            let version = data.version
            let hash = this.$version
            if (hash !== version) {
              // 当出现弹框时 禁止定时器，防止多个弹框
              clearInterval(this.intervalTime)
              this.intervalTime = null
              this.$confirm({
                title: '检测到新版本',
                content: '系统已经更新了，请刷新页面?',
                okText: '确定',
                okType: 'primary',
                cancelText: '1个小时后再通知我',
                onOk: () => {
                  window.location.reload(true)
                },
                onCancel () {
                  that.checkVersionHandler()
                }
              })
            }
          }
        }).catch(() => { })
      }, time)
    },
    // 监听浏览器页面是否更新
    checkVersionHandler () {
      const time = 60 * 1000 * 30 // 刷新时间间隔半小时
      this.checkVersion(time)
      this.$on('hook:beforeDestroy', () => {
        clearInterval(this.intervalTime)
        this.intervalTime = null
      })
    }
  }
}
</script>

<style lang="less">
@import './styles/index.css';
:global {
  .dragable-ghost {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-chose {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
  .dragable-drag {
    border: 1px dashed #aaaaaa;
    opacity: 0.65;
  }
}

::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

::-webkit-scrollbar-track {
  border-radius: 1px;
}
.ql-container.ql-snow {
  min-height: 50px;
  max-height: 450px;
  overflow-y: scroll;
}

::-webkit-scrollbar-thumb {
  border-radius: 1px;
  background: rgba(0, 0, 0, 0.2);
}

.multi-page {
  margin: -24px 0 0;
}

.single-page {
  margin: 0;
}

.card-area {
  width: 100%;
}

.not-menu-page {
  background: #fff;
  padding: 16px 32px;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.ant-btn,
.ant-input,
.input,
.ant-pagination-item,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link,
.ant-tag,
.ant-modal-content,
.ant-select-selection,
.ant-select-dropdown,
.ant-input-group-addon,
.ant-input-number-input,
.ant-input-number,
.ant-pagination-options-quick-jumper input,
.ant-alert {
  border-radius: 2px !important;
}

.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab,
.ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-radius: 3px 3px 0 0 !important;
}

.ant-card-wider-padding .ant-card-body {
  padding: 5px 10px !important;
}

.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.ant-modal-header {
  border-bottom-color: #fff !important;
}
.ant-modal .ant-modal-content .ant-modal-header .ant-modal-title {
  font-size: 18px !important;
}
.ant-modal .ant-modal-content .ant-modal-body .titleText {
  font-size: 22px !important;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) inset !important;
}

.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-item {
  margin-top: 0 !important;
}
.ant-menu-dark,
.ant-menu-dark .ant-menu-sub {
  background: #393e46 !important;
}

.ant-table-row-expand-icon {
  margin-right: 1rem !important;
}

:root .ant-tabs-tab-prev {
  border: 1px solid #e8e8e8;
  border-radius: 3px 0 0 0;
  background: #83c2fd;
}
.ant-card-loading {
  &:after {
    width: 0 !important;
  }
}
.ant-tabs-tab-next.ant-tabs-tab-arrow-show {
  border: 1px solid #e8e8e8;
  border-radius: 0 3px 0 0;
  background: #83c2fd;
}
.ant-layout-header,
.system-top-menu {
  height: 59px !important;
  line-height: 59px !important;
}
.ant-form-item {
  margin-bottom: 1rem !important;
  .ant-form-item-label {
    width: 160px !important;
  }
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: 0 solid #ccc !important;
}
.ant-drawer-body {
  padding-bottom: 3rem !important;
  .titleText {
    font-size: 18px !important;
  }
  .label div:first-child {
    width: 110px !important;
  }
}
.page-tabs .ant-tabs-close-x {
  color: #fff !important;
  margin-left: 0.3rem !important;
}
.page-tabs:hover .ant-tabs-close-x {
  color: #f95476 !important;
}
.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.search {
  margin-bottom: 0.5rem !important;
}
i {
  font-size: 0.97rem;
}
p {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  // white-space: nowrap;
}
@media screen and (min-width: 1400px) {
}

@media screen and (max-width: 1399px) {
  p,
  .ant-pagination,
  .ant-form,
  .ant-dropdown,
  .ant-form-item,
  .ant-select,
  .ant-breadcrumb,
  .ant-form label,
  .ant-btn,
  .ant-table,
  .ant-menu-vertical .ant-menu-item,
  .ant-menu-vertical-left .ant-menu-item,
  .ant-menu-vertical-right .ant-menu-item,
  .ant-menu-inline .ant-menu-item,
  .ant-menu-vertical .ant-menu-submenu-title,
  .ant-menu-vertical-left .ant-menu-submenu-title,
  .ant-menu-vertical-right .ant-menu-submenu-title,
  .ant-menu-inline .ant-menu-submenu-title {
    font-size: 13px !important;
  }
  .ant-card-head {
    font-size: 14px !important;
  }
  .page-tabs .ant-tabs-nav-container {
    font-size: 13px !important;
  }
}
.ant-form label,
.jineValue span {
  font-size: 18px !important;
}
.rowStyle {
  .title {
    width: 120px !important;
    // text-align: left !important;
    &::before {
      left: 125px !important;
    }
  }
  .value {
    padding-left: 135px !important;
  }
  .content_col {
    width: 100px !important;
  }
}

.ant-menu-item span,
.ant-menu-submenu .ant-menu-submenu-title span,
.ant-menu-submenu .ant-menu-sub span {
  font-size: 18px !important;
  /*font-weight: bold !important;*/
  font-family: var(--fontFam) !important;
}
.ant-cascader-menu {
  height: 110px;
}
body {
  font-family: var(--globalFont) !important;
}
/* 死亡事故-> 同期比较表头样式  #FFA07A  #FF4500*/
.periodStyle .ant-table-body .ant-table-thead > tr:not(:last-child) > th {
  background-color: #dceded;
  border: 1px solid #c3c3c3;
}
.periodStyle .ant-table-body .ant-table-thead > tr > th {
  background-color: #dceded;
  border: 1px solid #c3c3c3;
}
/* 用于处理表格固定左侧时，样式莫名不一样的情况*/
.ant-table-fixed-left {
  border-radius: 0 !important;
}
.resize-table-th {
  position: relative;
}

.table-draggable-handle {
  /* width: 10px !important; */
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue